<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/62/title-bg.png" alt="" />
            <div class="technological-process">
                <div class="rhtj mar-t2">
                    <img class="top" src="./../assets/imgs/62/title-1.png" alt="" />
                    <div class="content">
                        经我区相关部门认定并符合航空、轨道交通、电子信息等重点产业链企业目录的单位或来新都参加面试的人才。
                    </div>
                </div>
                <div class="rhtj mar-t2">
                    <img class="top" src="./../assets/imgs/62/title-2.png" alt="" />
                    <div class="content">申报具体条件，详见申报通知。</div>
                </div>

                <div class="zccl">
                    <img class="top" src="./../assets/imgs/62/title-3.png" alt="" />
                    <div class="content">
                        <div class="des">
                            <div class="title">一. 生活补贴</div>
                            对重点产业链企业新全职引进的高校应届毕业生给予生活补贴。<br />
                            1.
                            具有普通高等教育本科学历学位的，在职期间可享受一次性生活补贴1万元/人。<br />
                            2.
                            具有普通高等教育硕士研究生学历学位的，在职期间享受3万元/人的生活补贴，分两年平均拨付。<br />
                            3.
                            具有普通高等教育博士研究生学历学位的，在职期间享受10万元/人的生活补贴，分两年平均拨付。<br />
                            4.
                            具有普通高等教育大专及以上学历且在校期间获得技师（二级）职业资格（或技能等级）证书的，在职期间享受3万元/人的生活补贴，分两年平均拨付。<br />
                            5.
                            具有普通高等教育大专及以上学历且在校期间获得高级技师（一级）职业资格（或技能等级）证书的，在职期间享受10万元/人的生活补贴，分两年平均拨付。
                        </div>
                        <div class="des">
                            <div class="title">二. 实习补贴</div>
                            对吸纳高校在读全日制博士研究生、硕士研究生、本科生实习的新都区重点产业链企业，按照博士研究生3000元/月、硕士研究生2000元/月、本科生1000元/月标准给予补贴。
                        </div>
                        <div class="des">
                            <div class="title">三. 青年人才驿站</div>
                            对来新都求职应聘或应聘成功的普通高等教育本科及以上学历毕业生提供7天免费住宿。
                        </div>
                    </div>
                </div>
                <div class="gmlc">
                    <img class="top" src="./../assets/imgs/55/title-4.png" alt="" />
                    <div class="content">
                        <div class="des mar-t3">
                            <div class="title">生活补贴申报流程</div>

                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">1</div>
                                    <div class="line-title">印发申报通知</div>
                                </div>
                                <div class="line-content"></div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">2</div>
                                    <div class="line-title">申请</div>
                                </div>
                                <div class="line-content">
                                    毕业生填写申请表，企业向区高层次服务中心报送申请材料
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">3</div>
                                    <div class="line-title">初审</div>
                                </div>
                                <div class="line-content">
                                    区高层次人才服务中心初审
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">4</div>
                                    <div class="line-title">复审</div>
                                </div>
                                <div class="line-content">区人社局复审</div>
                            </div>
                            <div class="line-item">
                                <div class="line" style="height: 120%"></div>
                                <div class="line-top">
                                    <div class="line-num">5</div>
                                    <div class="line-title">公示</div>
                                </div>
                                <div class="line-content">
                                    区人社局将拟发放人员名单在政府网站上公示5个工作日
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line-top">
                                    <div class="line-num">6</div>
                                    <div class="line-title">发放</div>
                                </div>
                                <div class="line-content">
                                    对公示无异议的，发放补贴
                                </div>
                            </div>
                        </div>
                        <div class="des " style="margin-top: 0.8rem;">
                            <div class="title">实习补贴申报流程</div>

                            <!-- <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">1</div>
                                    <div class="line-title">备案</div>
                                </div>
                                <div class="line-content">
                                    企业将材料交团区委备案
                                </div>
                            </div> -->
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">1</div>
                                    <div class="line-title">申报</div>
                                </div>
                                <div class="line-content">
                                    团区委每年发布申报通知
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">2</div>
                                    <div class="line-title">初审</div>
                                </div>
                                <div class="line-content">
                                    企业将材料报区高层次人才服务中心初审
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">3</div>
                                    <div class="line-title">复审</div>
                                </div>
                                <div class="line-content">团区委复审</div>
                            </div>
                            <div class="line-item">
                                <div class="line" style="height: 120%"></div>
                                <div class="line-top">
                                    <div class="line-num">4</div>
                                    <div class="line-title">公示</div>
                                </div>
                                <div class="line-content">
                                    团区委通过新都区门户网站等平台向社会进行5个工作日的公示
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line-top">
                                    <div class="line-num">5</div>
                                    <div class="line-title">发放</div>
                                </div>
                                <div class="line-content">
                                    对公示无异议的，发放资金
                                </div>
                            </div>
                        </div>
                        <div class="des" style="margin-top: 0.8rem;">
                            <div class="title">青年驿站申请流程</div>

                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">1</div>
                                    <div class="line-title">申请</div>
                                </div>
                                <div class="line-content">
                                    申请人在入住前登录青年人才云服务平台网站“助你就业”板块（
                                    <a href="javascript:void">https://cloud.cdcyl.org.cn</a>
                                    ）,选择入住站点，阅读入住须知，填写信息资料，上传证明材料（身份证、学历证明或有效学生证件、应聘通知、入职证明等），完成注册申请
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">2</div>
                                    <div class="line-title">审核</div>
                                </div>
                                <div class="line-content">
                                    驿站管理员在24小时内完成申请人入住审核
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line-top">
                                    <div class="line-num">3</div>
                                    <div class="line-title">通知</div>
                                </div>
                                <div class="line-content">
                                    审核通过后，申请人将收到网站系统通知
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="contact" style="margin-top: 0.8rem">
                    <img class="top" src="./../assets/imgs/25/title-5.png" alt="" />
                    <div class="content">
                        <div class="number" style="padding-left: 1.2rem; margin-bottom: 0.22rem">
                            <span class="label">团区委：</span>
                            <div>
                                <a href="tel:028-83972952">028-83972952</a>
                            </div>
                        </div>
                        <div class="number" style="padding-left: 1.5rem;margin-bottom: 0.22rem">
                            <span class="label">区人社局：</span>
                            <div>
                                <a href="tel:028-89399625">028-89399625</a>
                            </div>
                        </div>
                        <div class="number">
                            <span class="label">人才服务专线：</span>
                            <div>
                                <a href="tel:028-67339999">028-67339999</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="codes">
                    <img class="code" src="../assets/imgs/62/code.png" />
                    <img class="text" src="../assets/imgs/62/text.png" />
                </div>
            </div>
        </section>
        <!-- <call phone="028-83221725"></call> -->
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 5.6rem;
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .rhtj {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                background: #ffffff;
                font-size: 0.26rem;
                color: #4e4e4e;
                text-align: left;
                position: relative;
                font-weight: 500;
            }
        }

        .zccl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.8rem;
                    position: relative;
                    text-align: left;

                    .title {
                        position: absolute;
                        top: -0.5rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 2.98rem;
                        height: 0.67rem;
                        line-height: 0.67rem;
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        font-size: 0.32rem;
                        font-weight: bold;
                        color: #ffffff;
                        border-radius: 1rem;
                        background-color: #739bfe;
                    }
                }
            }
        }

        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.55rem auto;
                padding: 0.87rem 0.33rem 0.35rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.45rem 0.23rem;
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;
                    position: relative;

                    .title {
                        position: absolute;
                        top: -0.5rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 4.5rem;
                        height: 0.67rem;
                        line-height: 0.67rem;
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        font-size: 0.32rem;
                        font-weight: bold;
                        color: #ffffff;
                        border-radius: 1rem;
                        background-color: #739bfe;
                    }

                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 130%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .line-title {
                            font-size: 0.3rem;
                            font-weight: bold;
                            color: #3d5aa3;
                        }

                        .line-top {
                            display: flex;
                            width: 3.31rem;
                            height: 0.49rem;
                            background-image: url(../assets/imgs/25/label.png);
                            background-size: 100% 100%;
                            z-index: 99;
                            display: flex;
                            align-items: center;
                            box-sizing: border-box;
                            padding-left: 0.08rem;

                            .line-num {
                                width: 0.39rem;
                                height: 0.39rem;
                                background: #fff;
                                color: #3d5aa3;
                                display: inline-flex;
                                border-radius: 50%;
                                justify-content: center;
                                align-items: center;
                                margin-right: 0.14rem;
                                position: relative;
                                z-index: 3;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 0.28rem;
                                font-weight: bold;
                            }
                        }

                        .line-content {
                            //   border-left: 0.02rem dashed #739bfe;
                            padding-bottom: 0.32rem;
                            margin-left: 0.2rem;
                            padding-left: 0.32rem;
                            padding-top: 0.15rem;
                            word-break: break-all;
                            line-height: 0.44rem;
                        }
                    }
                }
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .code {
                width: 1.94rem;
                height: 1.94rem;
            }

            .text {
                height: 1.65rem;
            }
        }
    }
}
</style>
